










import { Component, mixins } from '@niknevis/vue-modules'
import { FilterEntitySearchMixin } from '@/modules/common/filter/mixins/filterEntitySearchMixin'
import AdminDepartmentSearch from '@/modules/department/components/admin/AdminDepartmentSearch.vue'

@Component({
  components: {
    AdminDepartmentSearch
  }
})
export default class AdminDepartmentSearchFilter extends mixins(FilterEntitySearchMixin) {
}
